import { apiRequest } from '../core/http';
import {
  ME_ACCESS_ENDPOINT,
  ORGANIZATION_STATUS,
  isAccessRole,
  type MeAccess,
  type MeOrganization,
  type MeTeam,
} from './access.types';

function readOrganization(value: unknown): MeOrganization | null {
  if (!value || typeof value !== 'object') return null;
  const row = value as Record<string, unknown>;
  if (typeof row.uuid !== 'string' || typeof row.name !== 'string') return null;
  return {
    uuid: row.uuid,
    code: typeof row.code === 'string' ? row.code : '',
    name: row.name,
    status:
      row.status === ORGANIZATION_STATUS.SUSPENDED
        ? ORGANIZATION_STATUS.SUSPENDED
        : ORGANIZATION_STATUS.ACTIVE,
  };
}

function readTeam(value: unknown): MeTeam | null {
  if (!value || typeof value !== 'object') return null;
  const row = value as Record<string, unknown>;
  if (typeof row.uuid !== 'string' || typeof row.name !== 'string') return null;
  return { uuid: row.uuid, name: row.name };
}

/** GET /v1/me/access. Callers that already know the JWT admin claim must not use this. */
export async function getMeAccess(): Promise<MeAccess> {
  const raw = await apiRequest<unknown>('get', ME_ACCESS_ENDPOINT);
  const row = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {};
  if (!isAccessRole(row.role)) {
    throw new Error('Unexpected /v1/me/access role');
  }
  return {
    role: row.role,
    organization: readOrganization(row.organization),
    team: readTeam(row.team),
  };
}
